module.exports = __webpack_public_path__ + "media/images/emblems/Torricella-Taverne-coat_of_arms-494ee7359b83537cba5a0810a119bacc.svg";